module.exports = __webpack_public_path__ + "static/media/invoice-right-arrow.d239d3af.svg";